import {
  Component,
  ElementRef,
  HostListener,
  Inject, OnDestroy, OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import {
  MatDialog, MatDialogRef,
  MAT_DIALOG_DATA
} from '@angular/material';
import { ActivatedRoute, Router, Scroll } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { NzConfigService } from 'ng-zorro-antd/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { DocumentTypeEnterprise } from 'src/app/core/class/DocumentTypeEnterprise';
import { Message } from 'src/app/core/class/message';
import { LotType } from 'src/app/core/constants/lot-type';
import { ApiService } from 'src/app/core/services/api.service';
import { AutoEnterpriseService } from 'src/app/core/services/auto-enterprise.service';
import { AutoUserService } from 'src/app/core/services/auto-user.service';
import { CommonService } from 'src/app/core/services/common.service';
import { ContractLotService } from 'src/app/core/services/contract-lot.service';
import { CreateContractService } from 'src/app/core/services/create-contract.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { DataService } from 'src/app/core/services/data.service';
import { DocumentTemplateService } from 'src/app/core/services/document-template.service';
import { DocumentTypeService } from 'src/app/core/services/document-type.service';
import { DocumentService } from 'src/app/core/services/document.service';
import { EnterpriseService } from 'src/app/core/services/enterprise.service';
import { ContentType } from 'src/app/core/services/file-utils';
import { ImportLotService } from 'src/app/core/services/import-lot.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ProcessingService } from 'src/app/core/services/processing.service';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { BreadcrumbsService } from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';
import { UploadFileComponent } from 'src/app/shared/components/upload-file/upload-file.component';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';

@Component({
  selector: 'app-add-config-ip-with-file',
  templateUrl: './add-config-ip-with-file.component.html',
  styleUrls: ['./add-config-ip-with-file.component.scss'],
})
export class AddConfigIpWithFileComponent
  extends BaseComponent
  implements OnInit, OnDestroy {
  constructor(
    private documentService: DocumentService,
    private apiService: ApiService,
    private el: ElementRef,
    private createContractService: CreateContractService,
    public dialogRef: MatDialogRef<AddConfigIpWithFileComponent>,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    public message: Message,
    private toastr: ToastrService,
    public commonService: CommonService,
    private renderer: Renderer2,
    private modelService: NzModalService,
    private nzConfigService: NzConfigService,
    private customerService: CustomerService,
    public autoUserService: AutoUserService,
    private enterpriseService: EnterpriseService,
    public autoEnterpriseService: AutoEnterpriseService,
    private router: Router,
    private route: ActivatedRoute,
    private documentTypeService: DocumentTypeService,
    public documentTemplateService: DocumentTemplateService,
    private breadcrumbsService: BreadcrumbsService,
    public processingService: ProcessingService,
    private dataService: DataService,
    public importLotService: ImportLotService,
    public contractLotService: ContractLotService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super(commonService, message);
    dialogRef.disableClose = true;
    dialogRef.backdropClick().subscribe((_) => {
      this.onNoClick();
    });
  }
  @ViewChild(UploadFileComponent, { read: UploadFileComponent, static: false }) uploadFileComponent;
  @BlockUI() blockUI: NgBlockUI;
  errorFile: boolean = false;
  lastScrollTop = 0;
  fileName: string = "";
  fileBase64: string = "";
  documentTypeEnterprise: DocumentTypeEnterprise;
  fileCode: any = '';
  fileUpload: any[] = [];
  fileResult: any;
  numberRecordSuccess: number = 0;
  numberRecordFail: number = 0;
  ngOnInit() {
  }
  ngOnDestroy() {}

  onNoClick() {
    this.dialogRef.close(true);
  }

  getResultFile() {
    this.enterpriseService.getResultFile(this.fileResult).subscribe(res => {
      this.downLoadFile(res, 'application/octet-stream', this.fileResult);
    })
  }

  uploadFile() {
    const inputFile = document.getElementById("file");
    inputFile.click();
  }

  async onChangeFile(event: any) {
    this.fileUpload = []
    const temp = (<HTMLInputElement>document.getElementById("file")).files[0];
    this.fileUpload.push(temp)
    console.log(this.fileUpload);

    const accept: RegExp = /(\.xlsx)$/;
    if (!accept.exec(temp.name)) {
      this.toastr.error(
        this.message.getMessage("messages.error_file_type_excel")
      );
      return;
    }
    this.fileName = temp.name;
    this.fileBase64 = await this.getBase64(temp) as any;
    this.fileResult = null;
  }
  getBase64(file) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  downLoadFile(data: any, type: string, fileName: string) {
    const blob = new Blob([data], { type });
    if (window.top.navigator.msSaveOrOpenBlob) {
      // Store Blob in IE
      window.top.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // Store Blob in others
      const tA = document.body.appendChild(document.createElement('a'));
      tA.href = URL.createObjectURL(blob);
      tA.download = fileName;
      tA.style.display = 'none';
      tA.click();
      tA.parentNode.removeChild(tA);
    }
  }
  submit() {
    this.errorFile = false;
    if (!this.fileBase64) {
      this.toastr.error(this.message.getMessage('validation.error_not_have_file_lot'));
      return;
    }
    this.blockUI.start('');
    this.fileBase64 = this.fileBase64.replace('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,', '');
    this.uploadIp(this.fileUpload);
  }
  downFileTemplateExcelAddIp(e) {
    this.commonService.downFileTemplateExcelAddIp().subscribe(rs => {
      this.downLoadFile(rs, 'application/octet-stream', 'Template_import_ip.xlsx');
    })
  }

  uploadIp(fileUpload: any) {
    this.enterpriseService.importFromExcel(fileUpload)
      .subscribe(rs => {
        if (rs && rs.success && rs.data) {
          console.log(rs);
          this.fileResult = rs.data.fileResult;
          this.numberRecordSuccess = rs.data.numberRecordSuccess;
          this.numberRecordFail = rs.data.numberRecordFail;
          this.toastr.success(this.message.getMessage('config_enterprise.upload_ip_success'))
        } else {
          this.toastr.error(rs.message);
        }
        this.blockUI.stop();
      });
  }
}
